import { isNumber } from 'lodash'

export const CONTACT_UPDATE_SERVICES = {
  CONTACT_CHANGE: 'contactChange',
  PIN_CHANGE: 'pinChange',
}

const getCalculatedId = (template, parts) => {
  try {
    const indexes = template.split('$').filter(t => t)
    return indexes.reduce((result, index) => {
      if (isNumber(Number(index))) {
        result = `${result}${parts[index].value}`
      }
      return result
    }, '')
  } catch (error) {
    console.error(error)
    return ''
  }
}

const FIELD_TO_SERVICE = {
  'currentSecurityTanMedium': {
    service: CONTACT_UPDATE_SERVICES.CONTACT_CHANGE,
    parentFieldName: 'securityFunction',
    map: (modifiedContactSettings, initialContactSettings) => {
      const listElm = initialContactSettings.availableSecurityTanMediums.find(e => e.value === modifiedContactSettings.currentSecurityTanMedium)
      return {
        value: listElm.value,
        description: listElm.description,
        tanMediumType: listElm.tanMediumType,
      }
    },
  },
  'bicCode': {
    service: CONTACT_UPDATE_SERVICES.CONTACT_CHANGE,
    map: (modifiedContactSettings, initialContactSettings) => { return { bic: modifiedContactSettings.bicCode } },
  },
  'hbciVersion': {
    service: CONTACT_UPDATE_SERVICES.CONTACT_CHANGE,
    map: (modifiedContactSettings, initialContactSettings) => { return { hbciVersion: modifiedContactSettings.hbciVersion } },
  },
  'userId': {
    service: CONTACT_UPDATE_SERVICES.CONTACT_CHANGE,
    parentFieldName: 'userId',
    map: (modifiedContactSettings, initialContactSettings) => {
      return {
        calculatedId: getCalculatedId(initialContactSettings.userIdRaw.template, modifiedContactSettings.userIdRaw.parts),
        template: initialContactSettings.userIdRaw.template,
        parts: initialContactSettings.userIdRaw.parts.map((p, index) => {
          return { ...p, value: modifiedContactSettings.userIdRaw.parts[index].value ?? modifiedContactSettings.userId }
        }),
      }
    },
  },
  'scaMethodId': {
    service: CONTACT_UPDATE_SERVICES.CONTACT_CHANGE,
    parentFieldName: 'scaMethod',
    map: (modifiedContactSettings, initialContactSettings) => {
      const listElm = initialContactSettings.availableScaMethods.find(e => e.id === modifiedContactSettings.scaMethodId)
      return { ...listElm }
    },
  },
  'pin': {
    service: CONTACT_UPDATE_SERVICES.PIN_CHANGE,
    map: (modifiedContactSettings, initialContactSettings) => {
      return {
        pin: modifiedContactSettings.pin,
        storePin: true,
        useInvalid: false,
      }
    },
  },
}
FIELD_TO_SERVICE.userIdRaw = FIELD_TO_SERVICE.userId

export const mapContactSettingsToPsd2ContactChangeService = (modifiedContactSettings, initialContactSettings, globalValues = {}) => {
  if (!modifiedContactSettings) {
    return null
  }
  if (!initialContactSettings) {
    return null
  }

  const result = Object.entries(CONTACT_UPDATE_SERVICES).reduce((acc, [, value]) => {
    acc[value] = { }
    return acc
  }, { ...globalValues })

  for (const [field, fieldMeta] of Object.entries(FIELD_TO_SERVICE)) {
    if (field in modifiedContactSettings) {
      const mappedTargetValue = fieldMeta.map(modifiedContactSettings, initialContactSettings)
      let targetFieldStructure = result[fieldMeta.service]

      if (fieldMeta.parentFieldName?.length > 0) {
        if (!result[fieldMeta.service][fieldMeta.parentFieldName]) {
          result[fieldMeta.service][fieldMeta.parentFieldName] = { }
        }
        targetFieldStructure = result[fieldMeta.service][fieldMeta.parentFieldName]
      }
      targetFieldStructure = Object.assign(targetFieldStructure, mappedTargetValue)
    }
  }

  return result
}
